/** @format */

import { useEffect, ReactNode } from "react";
import { Container } from "../../components/layouts/Container";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";

const OldLogin = ({ children }: { children?: ReactNode }) => {
  const { navigateByAgent } = useNavigateByAgent();
  useEffect(() => {
    navigateByAgent("/ocnk/login?plan_code=ocnk");
  }, [navigateByAgent]);

  return <Container>{children}</Container>;
};

export default OldLogin;
